var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 220,
    viewBox: "0 0 240 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    filter: "url(#filter0_d_21_6127)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 120,
    cy: 88,
    r: 48,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MapPin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.833 77.264C114.6 78.0881 113.639 79.2594 113.071 80.6299C112.503 82.0003 112.355 83.5083 112.644 84.9632C112.933 86.418 113.648 87.7544 114.697 88.8033C115.746 89.8522 117.082 90.5665 118.537 90.8559C119.992 91.1453 121.5 90.9968 122.87 90.4291C124.241 89.8614 125.412 88.9001 126.236 87.6668C127.06 86.4334 127.5 84.9834 127.5 83.5C127.5 81.5109 126.71 79.6032 125.303 78.1967C123.897 76.7902 121.989 76 120 76C118.517 76 117.067 76.4399 115.833 77.264ZM117.5 87.2416C116.76 86.7471 116.183 86.0443 115.843 85.2221C115.502 84.3998 115.413 83.495 115.586 82.6221C115.76 81.7492 116.189 80.9474 116.818 80.318C117.447 79.6887 118.249 79.2601 119.122 79.0865C119.995 78.9128 120.9 79.0019 121.722 79.3425C122.544 79.6831 123.247 80.2599 123.742 80.9999C124.236 81.74 124.5 82.61 124.5 83.5C124.5 84.6935 124.026 85.8381 123.182 86.682C122.338 87.5259 121.193 88 120 88C119.11 88 118.24 87.7361 117.5 87.2416ZM108.338 71.8382C105.245 74.9315 103.505 79.1255 103.5 83.5C103.5 89.3875 106.221 95.6275 111.375 101.547C113.691 104.222 116.298 106.63 119.147 108.728C119.399 108.905 119.7 109 120.007 109C120.315 109 120.616 108.905 120.868 108.728C123.712 106.629 126.314 104.221 128.625 101.547C133.772 95.6275 136.5 89.3875 136.5 83.5C136.495 79.1255 134.755 74.9315 131.662 71.8382C128.569 68.7449 124.375 67.005 120 67C115.625 67.005 111.431 68.7449 108.338 71.8382ZM106.5 83.5C106.5 79.9196 107.922 76.4858 110.454 73.9541C112.986 71.4223 116.42 70 120 70C123.58 70 127.014 71.4223 129.546 73.9541C132.078 76.4858 133.5 79.9196 133.5 83.5C133.5 94.2306 123.099 103.188 120 105.625C116.901 103.188 106.5 94.2344 106.5 83.5Z",
    fill: "#E7454C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21_6127",
    x: 0,
    y: -20,
    width: 240,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_6127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_6127",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.59321f99dba27aed6aba4c74b75d10c3.svg";
export { ForwardRef as ReactComponent };